import { asType, post } from "./Request";

export async function cloneProject(token: string, id: string): Promise<Record<string, string>> {
  const response = await post(`project/clone/${id}`, token);
  return asType(response);
}
